import { Language, setI18nLang } from '@yandex-int/i18n';

setI18nLang((process.env.BEM_LANG as Language) || 'ru');
